export const makeRange = (size: number) =>
  Array.from({ length: size }, (_, index) => index)
